// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3OYku","label":"Category_label__28lgz","content":"Category_content__3Xcsi","header":"Category_header__3wB2r","location":"Category_location__iCOCo"};